export const features = {
  title: "Solicitações de funcionalidades",
  subtitle:
    "Contribua com o ecossistema da Araria e envie sua solicitação de funcionalidade, ou vote em funcionalidades existentes.",
  subtitle2:
    "Sua opinião é muito importante pra nós. Vote no que é mais importante pra você!",
  voteCount: "Votos",
  approve: "Aprovar",
  edit: "Editar",
  create: "Criar",
  votes: "Votos",
  unvote: "Remover voto",
  vote: "Votar",
  filter: "Filtrar por status",
  showMore: "Ver mais",
  showLess: "Ver menos",
  statusFlow: "Fluxo de Execução",
  statusFlowDescription:
    "As funcionalidades seguem este fluxo desde o envio até a conclusão.",
  status: {
    ALL: "Todas as funcionalidades",
    PENDING: "Pendente",
    PENDING_DESC: "Aguardando análise pelo administrativo",
    APPROVED: "Aprovado",
    APPROVED_DESC:
      "Aprovado pelo administrativo, aberto para votações de usuários",
    REJECTED: "Rejeitado",
    REJECTED_DESC:
      "Rejeitado pelo administrativo, não será aberto para votações, mas podemos decidir reabrir para votações no futuro",
    PLANNED: "Planejado",
    PLANNED_DESC:
      "Planejado para uma futura versão, mas não está em desenvolvimento",
    IN_PROGRESS: "Em andamento",
    IN_PROGRESS_DESC: "Em desenvolvimento",
    PAUSED: "Pausado",
    PAUSED_DESC: "Pausado temporariamente, mas não descartado",
    COMPLETED: "Concluído",
    COMPLETED_DESC: "Concluído e disponível para todos os usuários",
    DECLINED: "Declinado",
    DECLINED_DESC: "Foi decidido não incluir esta funcionalidade",
  },
  modal: {
    title: "Criar solicitação de funcionalidade",
    titleEdit: "Editando solicitação de funcionalidade",
    titleLabel: "Título",
    titlePlaceholder: "Digite o título da funcionalidade",
    descriptionLabel: "Descrição",
    descriptionPlaceholder: "Digite a descrição da funcionalidade",
    statusLabel: "Status",
    isPublished: "Tornar público",
    submit: "Enviar",
    update: "Atualizar",
    note: "Esta funcionalidade passará pelo administrativo, se aprovada, ficará visível para todos os usuários que poderão votar na mesma.",
  },
  error: {
    voting: "Erro ao submeter voto.",
    loading: "Erro ao carregar funcionalidades.",
    creating: "Erro ao criar solicitação de funcionalidade.",
    updating: "Erro ao atualizar solicitação de funcionalidade.",
  },
  success: {
    created: "Solicitação de funcionalidade criada com sucesso.",
    updated: "Solicitação de funcionalidade atualizada com sucesso.",
  },
};
